import { useStorefrontPathname } from '../../../modules/settings/hooks/useStorefrontPathname';
import PATHS from '../../routes.const';

const BASE_PATH_BY_SUB_NAV_CONTEXT = {
  settings: PATHS.main.settings.path,
  admin: PATHS.main.adminTeceo.path,
} as const;

export type SubNavContext = keyof typeof BASE_PATH_BY_SUB_NAV_CONTEXT;

const SUB_NAV_CONTEXTS = Object.keys(BASE_PATH_BY_SUB_NAV_CONTEXT) as SubNavContext[];

export const useSubNavContext = (pathname: string): SubNavContext | null => {
  const storefrontPathname = useStorefrontPathname();
  const currentPathname = pathname.replace(/\/+$/, '');

  if (currentPathname === storefrontPathname) {
    return 'settings';
  }

  const subNavContext = SUB_NAV_CONTEXTS.find((context) => {
    const basePath = BASE_PATH_BY_SUB_NAV_CONTEXT[context];

    return currentPathname === basePath || currentPathname.startsWith(`${basePath}/`);
  });

  return subNavContext ?? null;
};
